import { ref } from 'vue';

const getQualificationGroups = () => {
    const qualificationgroups_error = ref(null);
    const qualificationgroups = ref(null);

    const loadQualificationGroups = async (qualification_group_id = null) => {
      try {
        var params = [];

        if (qualification_group_id) {
          params.push(['qualification_group_id', qualification_group_id]);
        }
        
        let data = await fetch("/api/qualificationgroups?" + new URLSearchParams(params));

        if (!data.ok) {
          throw Error("Can't load data");
        }
        qualificationgroups.value = await data.json();
      } catch (err) {
        qualificationgroups_error.value = err.message;
      }
    };

    return { qualificationgroups, qualificationgroups_error, loadQualificationGroups};
}

export default getQualificationGroups;
